var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 5.516a3.376 3.376 0 0 0-6.75 0c0 .29.105.74.359 1.34.246.582.595 1.224.996 1.873A34 34 0 0 0 7 11.603a33 33 0 0 0 2.02-2.874c.401-.649.75-1.291.996-1.872.254-.6.359-1.05.359-1.341m1.125 0c0 2.048-2.742 5.695-3.945 7.2a.708.708 0 0 1-1.11 0C5.242 11.211 2.5 7.564 2.5 5.516a4.501 4.501 0 0 1 9 0m-3.75 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0m-2.625 0a1.875 1.875 0 1 1 3.75 0 1.875 1.875 0 0 1-3.75 0"
  })));
};
export default SvgLocation;